// src/data/allGames.js
//import BASE_GAMES from "./baseGames";

const API_URL = "https://kepithor.xyz/api/games2.php";

let allGamesCache = null;
let loadingPromise = null;

function dedupeGames(games) {
  const seen = new Set();
  const result = [];

  for (const g of games) {
    const key = `${g.id}|${g.webglPath || ""}`;
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(g);
  }

  return result;
}

async function fetchWithRetry(url, retries = 3, delay = 800) {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return await res.json();
    } catch (err) {
      console.warn(`[fetchWithRetry] Attempt ${attempt} failed:`, err);

      if (attempt === retries) throw err; // give up

      // wait before retrying
      await new Promise((r) => setTimeout(r, delay * attempt));
    }
  }
}


export async function loadAllGames() {
  // Already loaded in this JS runtime
  if (allGamesCache) return allGamesCache;

  // Fetch already in progress
  if (loadingPromise) return loadingPromise;

  loadingPromise = (async () => {
    let partnerGames = [];

  try {
  const data = await fetchWithRetry(API_URL, 3, 600);
  partnerGames = Array.isArray(data.games) ? data.games : [];
  // console.log("[AllGames] from API:", {
  //   thop: data.thopCount,
  //   gamepix: data.gamepixCount,
  //   total: data.totalPartners,
  // });
} catch (err) {
  console.error("Error fetching partner games after retries:", err);
}
    //const merged = dedupeGames([...BASE_GAMES, ...partnerGames]);
    const merged = dedupeGames(partnerGames);
    allGamesCache = merged;
    loadingPromise = null;
    return merged;
  })();

  return loadingPromise;
}

export function getAllGamesSync() {
  // Before the first load, just return your built-in games
  //return allGamesCache || BASE_GAMES;
  return allGamesCache || [];
}

export function isAllGamesLoaded() {
  return !!allGamesCache;
}
